export default __webpack_public_path__ + "static/Save-Win-8f7efc5871f8ddc1e57d3cad63a38134.webp";